import {
  getCountryFormList,
  getCountryList,
  pathCreateCountry,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { countryActions } from "../reducers/country";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchCountryList = (id_country = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCountryList(id_country))
      .then((response) => {
        id_country == 0
          ? dispatch(countryActions.fetchCountryList(response.data))
          : dispatch(countryActions.fetchCountryDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCountryFormList = (id_country = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCountryFormList(id_country))
      .then((response) => {
        dispatch(countryActions.fetchCountryFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewCountry = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateCountry(), data)
      .then((response) => {
        // dispatch(countryActions.fetchCountryList(response.data));
        toast.success(t("countryListActions.created"), {
          theme: "colored",
        });
        navigate("/country-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditCountry = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateCountry(), data)
      .then((response) => {
        // dispatch(countryActions.fetchCountryList(response.data));
        toast.success(t("countryListActions.updated"), {
          theme: "colored",
        });
        navigate("/country-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
